import {
  usePlayersStore,
} from "@/stores";
export function updateHandRaisedAt([index, value]: [number, number | null]) {
  const playersStore = usePlayersStore();
  const player = playersStore.players[index];
  if (!player) return;

  playersStore.update({
    player,
    property: "handRaisedAt",
    value: value ? new Date().valueOf() : null,
    isFromSocket: true,
  });
}
